import React, { Component, useState } from "react";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import { Dialog, makeStyles } from "@material-ui/core";
import "./create-invoice.scss";
import Box from "@material-ui/core/Box";
import moment from "moment";
import "moment/locale/ru";
import SelectReact from "react-select";
import { customStyles } from "../../../../trainers/trainer/edit-trainer";
import { useDispatch, useSelector } from "react-redux";
import { requestGroupSchedule } from "../../../../../store/actions/selects";
import { SpinnerLocal } from "../child";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ClearIcon from '@material-ui/icons/Clear';
import DatePicker from "react-datepicker";

const useStyles = makeStyles({
  dialog: {
    padding: "2rem",
  },
})

export const getMonths = (month, year) => {
    const ar = [];
    const start = moment(year + "-" + month, "YYYY-MMM");
    for (
        const end = moment(start).add(1, "month");
        start.isBefore(end);
        start.add(1, "day")
    ) {
        ar.push(start.format(`YYYY-MM-DD,D MMMM,dddd`).split(","));
    }
    return ar.map((el) => ({
        date: el[0],
        day: el[1],
        dayName: el[2],
    }));
};

export const years = (future) => {
  const year = new Date().getFullYear();
  return Array.from({ length: future }, (v, i) => year + i);
};

class CreateInvoiceContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      select: false,
      startDate: null,
      endDate: null,
      monthsList: [],
      sortScheduleMonth: [],
      valid: [],
      children_id: "",
      group_id: "",
      refund_flag: false
    };
  }

  componentDidMount() {
    if (this.props.groupsPlan.length === 1) {
      this.props.groupShedule(this.props.groupsPlan[0].id);
    }
    const days = moment.weekdays();
    const dayList = days.concat(days.shift()).map((item, index) => ({
      id: index,
      name: item,
    }))

    this.setState({
      dayList: dayList,
    });
    if (this.props.groupsPlan.length !== 0) {
      this.setState({
        group_id: this.props.groupsPlan[0].id,
        children_id: this.props.children_id,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.scheduleGroup.length > 0 &&
      this.props.scheduleGroup.length !== this.state.sortScheduleMonth.length
    ) {
      const scheduleMonth = this.props.scheduleGroup.map((item) => ({
        id: item.id,
        date: item.start,
        start: moment(item.start).format("HH:mm"),
        end: moment(moment(item.start).format("HH:mm"), "HH:mm")
          .add(item.duration, "minutes")
          .format("HH:mm"),
        dayName: moment(item.start).format("dddd"),
        day: moment(item.start).format("D MMMM"),
        duration: item.duration,
      }));
      const sortScheduleMonth = scheduleMonth.sort(
        (a, b) => moment(a.date) - moment(b.date)
      );

      this.setState({
        sortScheduleMonth: sortScheduleMonth,
      });
    }
  }

  handleDivClicked = (event) => {
    const { valid } = this.props.invoice;
    const validNew = valid.find((item) => item.date === event.date)
      ? valid.filter((item) => item.date !== event.date)
      : [...valid, event];
    this.props.setInvoice({
      valid: validNew,
      children_id: this.state.children_id,
      group_id: this.state.group_id,
      count: validNew.length,
      is_refundable: this.state.refund_flag
    });
  };

  setGroup = (group) => {
    this.props.groupShedule(group.id);
    this.setState({ group_id: group.id });
  };

  effectForRefundFlag = () => {
      const {invoice: {count}, invoice} = this.props
      if (count > 0) {
          this.props.createInvoice({
              ...this.props.invoice,
              estimation: true,
              is_refundable: this.state.refund_flag
          })
      }

      this.props.setInvoice({
          ...invoice,
          is_refundable: this.state.refund_flag
      });
  }
  onRefundHandler = (e) => {
      this.setState({refund_flag: e.target.checked}, this.effectForRefundFlag)
  }
  setDateByType = (date, target) => {
      this.setState({[target]: date} )
  }
  onDateChange = (dates) => {
      const [start, end] = dates;
      this.setDateByType(start, 'startDate')
      this.setDateByType(end, 'endDate')
      const s = moment(start).format('YYYY-MM-DD')
      const e = moment(end).format('YYYY-MM-DD')
      if (start && end) {
          this.getInvoicesByDates(s, e)
      }
  }
  onDateClean = () => {
      this.setDateByType(null, 'startDate')
      this.setDateByType(null, 'endDate')
      const { group_id } = this.state
      const today = moment()
          .format("YYYY-MM-DD")
      const payload = {
          start: today,
          group_id
      }
      this.props.refreshInvoices(payload)
  }

  getInvoicesByDates = (start, end) => {
      const { group_id } = this.state
      const payload = {
          group_id,
          start,
          end
      }
      this.props.refreshInvoices(payload)
  }

  render() {
    const { sortScheduleMonth, group_id, refund_flag, startDate, endDate } =
      this.state;

    const { invoiceDiscount, loadingSchedule, invoice } = this.props;

    const filterSchedule = sortScheduleMonth

    return (
      <Box className="containerCreateInvoice">
        <Box className="headerCreateInvoice">
              <span>Период</span>
              <DatePicker
                  disabled={loadingSchedule}
                  selected={startDate}
                  onChange={this.onDateChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="dd-MM-yyyy"
                  locale="ru"
            />
          { startDate && endDate && !loadingSchedule && (<ClearIcon className="clear-icon-cl" onClick={this.onDateClean}/>)}
          {this.props.groupsPlan.length > 1 && (
            <>
              <span className="headerCreateInvoiceYear">Группа:</span>
              <SelectReact
                className="selectCreateInvoice"
                name="groups"
                placeholder="Выбрать группу"
                getOptionLabel={(x) => x.name}
                getOptionValue={(x) => x.name}
                options={this.props.groupsPlan}
                styles={customStyles}
                onChange={this.setGroup}
              />
            </>
          )}
        </Box>
        <Box className="contentCreateInvoice">
          <Box className="сalendarCreateInvoice">
            {!loadingSchedule ? (
              <>
                {sortScheduleMonth.length > 0 && group_id ? (
                  filterSchedule.length > 0 ? (
                    filterSchedule.map((item) => (
                      <Box
                        className={
                          this.props.invoice.valid.findIndex(
                            (el) => el.date === item.date
                          ) > -1
                            ? "сalendarCreateInvoiceBoxSelect item--xs"
                            : "сalendarCreateInvoiceBox item--xs"
                        }
                        onClick={() => this.handleDivClicked(item)}
                        key={item.id}
                      >
                        <span className="calendarCreateDate">{item.day}</span>
                        <span className="calendarCreateTime">{`${item.start}-${item.end}`}</span>
                        <span className="calendarCreateDay">
                          {item.dayName}
                        </span>
                      </Box>
                    ))
                  ) : (
                    <h1>Нет расписания</h1>
                  )
                ) : (
                  <h1>
                    Не была выбрана активная группа или у группы нет расписания
                  </h1>
                )}
              </>
            ) : (
              <SpinnerLocal />
            )}
          </Box>
          <Box className="сalculateCreateInvoice">
            <h3>Выбор:</h3>
              <Box className="сalculateCreateInvoiceHeader">
                  <FormControlLabel control={<Checkbox color="primary" checked={refund_flag}
                                                       disabled={invoice.count < 1}
                                                       onChange={this.onRefundHandler}
                  />} label={"Возвратный абонемент"} />
              </Box>
            <Box className="сalculateCreateInvoiceHeader">
              <label className="сalculateCreateInvoiceHeaderLabel">
                Занятий <span>{invoiceDiscount?.count || 0}</span>
              </label>
              <span>={invoiceDiscount?.start_price || 0} р.</span>
            </Box>
            <Box className="calculateCreateInvoiceContent">
              {invoiceDiscount?.discounts && invoiceDiscount.discounts.length
                ? invoiceDiscount?.discounts.map((item, index) => (
                    <Box key={index}>
                      <label>{item.name}</label>
                      <span>{item.value} р.</span>
                    </Box>
                  ))
                : null}
            </Box>
              {invoiceDiscount.refundable_part ? <Box className="calculateCreateInvoiceContent">
                <Box>
                    <label>Возвр. абонемент (+10%)</label>
                    <span>{invoiceDiscount.refundable_part} р.</span>
                </Box>
             </Box> : null}
            <hr />
            <Box className="calculateCreateInvoiceFooter">
              <label>Итоговая стоимость:</label>
              <span>{invoiceDiscount?.price || 0} р.</span>
            </Box>
            <Button
              disabled={this.props.invoice.valid.length === 0}
              onClick={() =>
                this.props.createInvoice({
                  ...this.props.invoice,
                  estimation: true,
                  is_refundable: refund_flag
                })
              }
              className="calculateCreateInvoiceButton"
              variant="contained"
            >
              Рассчитать
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }
}

const CreateInvoice = (props) => {
  const {
    onClose,
    open,
    groupsPlan,
    children_id,
    createInvoice,
    invoiceDiscount,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const loadingSchedule = useSelector(
    (state) => state.selects.scheduleGroupLoading
  );
  const openScheduleGroup = (id) => {
    const today = moment()
        .format("YYYY-MM-DD")
    const payload = {
        start: today
    }
    dispatch(requestGroupSchedule(id, children_id, payload));
  }
  const refreshInvoices = (payload) => {
      const {group_id, start, end}  = payload
      const params = {
          start: start ? start + ' 00:00:00' : null,
          end: end ? end + ' 23:59:59' : null
      }
      dispatch(requestGroupSchedule(group_id, children_id, params));
  }
  const [invoice, setInvoice] = useState({
    valid: [],
    children_id: "",
    group_id: "",
    count: "",
    is_refundable: false
  });

  const scheduleGroup = useSelector((state) => state.selects.scheduleGroup);

  const [openDialog, setOpenDialog] = useState(false);
  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-create-invoice"
        classes={{
          paper: classes.dialog,
        }}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle id="form-dialog-create-invoice-title">
          Новый абонемент
        </DialogTitle>
        <DialogContent>
          <CreateInvoiceContent
            groupsPlan={groupsPlan}
            children_id={children_id}
            setInvoice={setInvoice}
            invoice={invoice}
            createInvoice={createInvoice}
            invoiceDiscount={invoiceDiscount}
            groupShedule={openScheduleGroup}
            scheduleGroup={scheduleGroup}
            loadingSchedule={loadingSchedule}
            refreshInvoices={refreshInvoices}
          />
        </DialogContent>
        <DialogActions id="form-dialog-create-invoice-active">
          <Button
            onClick={() => onClose(false)}
            color="primary"
            variant="contained"
            id="closeBtn"
          >
            Назад
          </Button>
          <Button
            onClick={() => {
              invoice.valid.length > 0
                ? createInvoice({ ...invoice, estimation: false })
                : setOpenDialog(true);
            }}
            color="primary"
            variant="contained"
          >
            Создать
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialog}
        aria-labelledby="form-dialog-confirm-invoice"
        fullWidth
        maxWidth={"xs"}
      >
        <DialogTitle id="form-dialog-confirm-invoice-title">Ошибка</DialogTitle>
        <DialogContent id="form-dialog-confirm-invoice-content">
          <h3>Занятия не выбраны</h3>
        </DialogContent>
        <DialogActions id="form-dialog-confirm-invoice-active">
          <Button
            id={"form-dialog-confirm-btn"}
            onClick={() => setOpenDialog(false)}
            color="primary"
            variant="contained"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateInvoice;
